<template>
	<center v-if="idat">
		<div class="info6">
			<h1>{{idat.heading}}</h1>
			<img v-bind:src="idat.img">
			<div class="marker-container">
				<div v-for="(mark,i) in idat.markers" class="marker" 
             @click="markerClick" v-bind:style="'top:' + mark.pos.x + 'px; left:' + mark.pos.y + 'px;'" 
             v-bind:dat-did='"desc-" + i' v-bind:key='"desc-marker-" + i'>
          <font-awesome-icon icon="fa fa-map-pin" style="color: white;"></font-awesome-icon>
					<div class="title">{{mark.title}}</div>
				</div>
			</div>
			<div v-for="(mark,i) in idat.markers" class="marker-description" v-bind:id='"desc-" + i' v-bind:key='"desc-desc-" + i'>
				<button onclick="this.parentElement.classList.remove('active')">X</button>
				<div class="dat" v-html="mark.descr"></div>
			</div>
		</div>
	</center>
</template>

<script type="text/javascript">
	import { ajaxGet,ajaxPost } from "../../../ajax";
  import {apiUrl} from "@/main";
	export default{
		data: function(){
			return {
				idat: undefined,
				infoId: undefined
			}
		},
		methods: {
			markerClick(e){
        console.log(e);
				var id = e.srcElement.parentElement.getAttribute("dat-did");
				if(id == null) id = e.srcElement.getAttribute("dat-did");
				document.querySelectorAll(".marker-description").forEach(md=>{
					md.classList.remove("active");
				});
				document.querySelector("#" + id).classList.add("active");
			}
		},
		created(){
      this.infoId = this.$router.history.current.params.infoId;
            var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
            ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.infoId,
				(dat) => {
					//on success dat is called
					if(dat.component == "infographic6"){
						//This is the right component
						this.idat = dat.data;
                    	window.document.title = dat.title;
                    	this.isAnswered = dat.answers;
	                    //----------------------------------------------------------
	                    if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
	                        ajaxPost(apiUrl() +"/assignments/" + this.infoId, {
	                        Data: {
	                            seen: Date.now()
	                        }
	                    },
	                    (suc) => {
	                        console.log("Posted assignment:", suc);
	                    },
	                    (err) => {
	                        console.log("Error :", err)
	                    }, localStorage.token);
	                    }
	                    //----------------------------------------------------------
					}else{
						//Wrong component type
						console.error("DATA MISMATCH on api call expected 'GALLERY' object, got '" + dat.component.toUpperCase() + "' object.");
					}
				},(err) => {
					//There was some error
					console.log(err);
				}, localStorage.token);
		}
	}
</script>
<style scoped>
.marker-container{
	position: absolute;
	width: 800px;
	height: 600px;
}
.marker{
	position: absolute;
	background: #9e2114dd;
	border-radius: 10px;
	cursor: pointer;
}
.marker .title{
	color: white;
}
.marker-description{
	position: absolute;
	bottom: 0;
	max-width: 800px;
	border: 1px solid black;
	background: #fffd;
	border-radius: 10px;
	display: none;
	padding: 10px 10px 0px 10px;
}
.marker-description.active{
	display: block;
}
.marker-description .dat{
	text-align: left;
}
.marker-description button{
	position: absolute;
	top: -10px;
	right: 10px;
	background: #720000dd;
	color: white;
	font-weight: bold;
	border-radius: 50%;
}
	h1{
		font-size: 1.5em;
		color: white;
		position: absolute;
		background: #9e211499;
		padding: 2px 30px;
		border-radius: 10px;
		max-width: 800px;
	}
	.info6{
	    position: relative;
	    top: 75px;
	    width: 100%;
	    height: 600px;
	    max-width: 100%;
	    max-height: 600px;
	    overflow: auto;
	    display:flex;
	    align-items: center;
	    flex-direction: column;
		background: #000000; /* Old browsers */
		background: -moz-linear-gradient(45deg, #000000 0%, #45484d 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(45deg, #000000 0%,#45484d 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(45deg, #000000 0%,#45484d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#45484d',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
	}
	.info6 > img{
		width: 800px;
		height: 100%;
		object-fit: contain;
	}
	/*.markers{
		position: absolute;
		top : 100;
		left: 100;
	}*/
</style>